export var Difficulty;
(function (Difficulty) {
    Difficulty["OFFICIAL"] = "Official";
    Difficulty["EASY"] = "Easy";
    Difficulty["MEDIUM"] = "Medium";
    Difficulty["HARD"] = "Hard";
    Difficulty["INSANE"] = "Insane";
    Difficulty["EXTREME"] = "Extreme";
})(Difficulty || (Difficulty = {}));
